export default "__VITE_ASSET__DC01Q1Q___"